/* eslint-disable react/prop-types */

const GENERIC_REASON = "An unexpected error occurred while submitting the pipeline.";
const SERVER_ERROR_REASON = "An unexpected server error occurred while submitting the pipeline. Please try again; if this keeps happening, contact support and quote this error code.";
const SAGA_DEFAULT_MESSAGE = "Run pipeline failed";
const SAGA_DEFAULT_CODE = "failed";

export const describePipelineRunError = (error) => {
    const err = error || {};
    const code = err.serverCode || (err.code !== SAGA_DEFAULT_CODE && err.code) || "UNKNOWN";
    const serverMessage = err.serverMessage || err.message;

    switch (code) {
        case "BAD_CONFIGURATION":
            // Unsanitised 500 from ControllerBase.handleError — message may carry AWS/DynamoDB internals.
            return { code, reason: SERVER_ERROR_REASON };
        case "VIEW_PERMISSION_REQUIRED":
            return {
                code,
                reason: `${err.serverMessage || "You need Views permissions in this business area to generate a materialized view."} Ask your tenant administrator for Views create/update and list access in this business area.`,
            };
        case "PERMISSION_DENIED":
            return { code, reason: "You don't have permission to execute this pipeline. Ask your tenant administrator for access." };
        case "NO_ENABLED_STEPS":
            return { code, reason: "This pipeline has no enabled transformation steps. Enable at least one step, save the pipeline, and try again." };
        case "PIPELINE_NOT_FOUND":
        case "NOT_FOUND_ERROR":
            return { code, reason: "This pipeline no longer exists — it may have been deleted. Close the builder and reload the pipeline list." };
        case "DATASET_NOT_FOUND":
            return { code, reason: "The source dataset for this pipeline could not be found. It may have been deleted." };
        case "ERR_NETWORK":
            return { code, reason: "Could not reach the server. Check your connection and try again." };
        default:
            return {
                code,
                reason: serverMessage && serverMessage !== SAGA_DEFAULT_MESSAGE ? serverMessage : GENERIC_REASON,
            };
    }
};

export const PipelineRunErrorMessage = ({ error }) => {
    const { reason, code } = describePipelineRunError(error);
    return (
        <span data-testid="pipeline-run-error">
            <strong>Failed to execute pipeline</strong>
            <br />
            {reason}
            <br />
            <small>Error code: {code}</small>
            <br />
            <small>No job was submitted, so this attempt will not appear in Jobs.</small>
        </span>
    );
};
